import { normalizeSteps, toRow } from '../../../pages/system/kyc-shared.js';

function normalizeJurisdictions(payload) {
  if (Array.isArray(payload)) {
    return payload;
  }

  const candidates = [
    payload?.jurisdictions,
    payload?.jurisdiction,
    payload?.items,
    payload?.data,
  ];

  for (const candidate of candidates) {
    if (Array.isArray(candidate)) {
      return candidate;
    }

    if (candidate && typeof candidate === 'object') {
      const values = Object.values(candidate);
      if (values.length > 0 && values.some((item) => item && typeof item === 'object' && ('uid' in item || 'name' in item))) {
        return values;
      }
    }
  }

  if (payload && typeof payload === 'object' && (payload.uid || payload.id || payload.name)) {
    return [payload];
  }

  return [];
}

export function mapJurisdictionsResponseToDto(payload) {
  return normalizeJurisdictions(payload).map((item, index) => {
    const id = String(item?.uid || item?.id || `jurisdiction-${index}`).trim();
    const name = String(item?.name || id).trim() || id;
    return { id, name };
  }).filter((item) => item.id);
}

export function mapKycSettingsResponseToDto(payload) {
  return normalizeSteps(payload)
    .map(toRow)
    .sort((a, b) => a.order - b.order)
    .map((row, index) => ({ ...row, order: index }));
}

